import type { TOC } from '@ember/component/template-only';

interface EmptyStateSignature {
  Args: {
    description?: string;
    imgClass?: string;
    title: string;
  };
  Blocks: {
    description?: [];
    default: [];
  };
}

export default <template>
  <div data-test-empty-state class="grid mx-auto content-center justify-items-center h-full max-w-[485px] text-center">
    {{#if @imgClass}}
      <div data-test-empty-state-img class="{{@imgClass}} mx-auto mb-10" />
    {{/if}}
    <h1 class="text-2xl mb-4" data-test-empty-state-title>
      {{@title}}
    </h1>
    {{#if (has-block "description")}}
      <p class="mb-6 text-carbon-60" data-test-empty-state-description>
        {{yield to="description"}}
      </p>
    {{else if @description}}
      <p class="mb-6 text-carbon-60" data-test-empty-state-description>
        {{@description}}
      </p>
    {{/if}}
    {{yield}}
  </div>
</template> satisfies TOC<EmptyStateSignature>;
